// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 9326 ? "f70991a6" : chunkId) + "." + {"2911":"9f20d5e3cc85b904","9326":"c9a0563ea3e2f9fe"}[chunkId] + ".js";
};